import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import icon from '../images/icon-n.png';
import ricon from '../images/icon-n-r.png';
import instructions from '../images/instruct-n.png';
import Rinstructions from '../images/r-instruct-n.png';


const handleQuitInstructions = () => {
    const instructionsDiv = document.getElementById('instructions-div');
    if (instructionsDiv) {
        instructionsDiv.style.display = 'none';
    }
};

const SelectorSearch = ({
  opciones,
  value,
  onChange,
  placeholder = "Seleccione",
  isDisabled = false,
  className = "",
  classNamePrefix = "",
}) => {
  const options = (opciones || []).map((o) => ({
    value: o.id,
    label: o.nombre,
  }));

  const selected =
    options.find((opt) => String(opt.value) === String(value)) || null;

  return (
    <Select
      className={className}
      classNamePrefix={classNamePrefix}
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : "")}
      placeholder={placeholder}
      isSearchable
      isClearable
      isDisabled={isDisabled}
      noOptionsMessage={() => "Sin resultados"}
    />
  );
};;


const SlideComponent = ({ actual, first, second, onSaveAnswers }) => {
    const [test, setTest] = useState(null);
    const [currentTest, setCurrentTest] = useState(null);
    const [selectorVariedad, setSelectorVariedad] = useState('');
    const [selectorPais, setSelectorPais] = useState('');
    const [selectorRegion, setSelectorRegion] = useState('');
    const [selectorBodega, setSelectorBodega] = useState('');
    const [selectorMarca, setSelectorMarca] = useState('');
    const [selectorAnada, setSelectorAnada] = useState(0);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [title, setTitle] = useState(null);

    const selectedButtonGroup0 = localStorage.getItem('selected0');
    const selectedButtonGroup1 = localStorage.getItem('selected1');
    const selectedButtonGroup2 = localStorage.getItem('selected2');
    const selectedButtonGroup3 = (JSON.parse(localStorage.getItem('selected3') || '[]'));
    const selectedButtonGroup4 = (JSON.parse(localStorage.getItem('selected4') || '[]'));
    const selectedButtonGroup5 = (JSON.parse(localStorage.getItem('selected5') || '[]'));
    const selectedButtonGroup6 = JSON.parse(localStorage.getItem('selected6') || '{}');
    console.log(selectedButtonGroup6);

    
    useEffect(() => {
    const nextButton = document.querySelector('.btn-next');

    if (!nextButton) return;

    const isReady =
        selectorVariedad !== '' &&
        selectorPais !== '' &&
        selectorRegion !== '' &&
        selectorBodega !== '' &&
        selectorMarca !== '' &&
        selectorAnada !== null &&
        selectedPrice !== '' &&
        selectedPrice !== null;

    nextButton.disabled = !isReady;

    }, [
    selectorVariedad,
    selectorPais,
    selectorRegion,
    selectorBodega,
    selectorMarca,
    selectorAnada,
    selectedPrice
    ]);

    useEffect(() => {
        // Obtener el currentTest de localStorage
        const currentTest = JSON.parse(localStorage.getItem('currentTest'));
        const savedTest = JSON.parse(localStorage.getItem('currentTest') || '[]');
        setTitle(savedTest.title);
        if (currentTest) {
            fetchTestDetails(currentTest.id);
        }
    }, []);
    const fetchTestDetails = (testId) => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/getTest/${testId}`;
        xhr.open("GET", url, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                setTest(data.object);
                setCurrentTest(data.title);
                console.log("Test Details Loaded: ", data);
            }
        };
        xhr.send();
    };
    const handlePaisChange = (value) => {
    setSelectorPais(value);
    setSelectorRegion('');
    setSelectorBodega('');
    setSelectorMarca('');
    };

    const handleRegionChange = (value) => {
    setSelectorRegion(value);
    setSelectorBodega('');
    setSelectorMarca('');
    };

    const handleBodegaChange = (value) => {
    setSelectorBodega(value);
    setSelectorMarca('');
    };
    
    const handlePriceClick = (value) => {
    setSelectedPrice(value);
    };

    const opcionesAnada = [
    { id: 0, nombre: 'Sin añada' },
    ...Array.from({ length: 2026 - 1975 + 1 }, (_, i) => {
        const year = 1975 + i;
        return { id: year, nombre: String(year) };
    })
    ];

    const variedadQuestion = Array.isArray(test)
    ? test.find(q => q.title === "Variedad")
    : null;

    const variedadData = variedadQuestion?.question || [];

    const opcionesVariedad = variedadData.map(v => ({ id: v.option, nombre: v.option }));
    // Obtener estructura Pais -> Region -> Bodega -> Marca
    const paisQuestion = Array.isArray(test)
    ? test.find(q => q.title === "Pais")
    : null;

    const paisData = paisQuestion?.question || [];

    const opcionesPais = paisData.map(p => ({ id: p.Pais, nombre: p.Pais }));

    const opcionesRegion = selectorPais
    ? (paisData.find(p => p.Pais === selectorPais)?.regiones || [])
        .map(r => ({ id: r.region, nombre: r.region }))
    : [];

    const opcionesBodega = (selectorPais && selectorRegion)
    ? (paisData.find(p => p.Pais === selectorPais)?.regiones?.find(r => r.region === selectorRegion)?.bodegas || [])
        .map(b => ({ id: b.bodega, nombre: b.bodega }))
    : [];

    const opcionesMarca = (selectorPais && selectorRegion && selectorBodega)
    ? (paisData
        .find(p => p.Pais === selectorPais)
        ?.regiones?.find(r => r.region === selectorRegion)
        ?.bodegas?.find(b => b.bodega === selectorBodega)
        ?.marcas || [])
        .map(m => ({ id: m.marca, nombre: m.marca }))
    : [];
    
    const priceQuestion = Array.isArray(test)
    ? test.find(q => q.title === "Precio")
    : null;

    const priceOptions = (priceQuestion?.question || []).map(p => ({
    value: p.option,  // OJO: ahora value es el texto tal cual del Excel
    label: p.option,
    }));

    const dulzorWords = ['Seco', 'Casi seco', 'Semiseco', 'Semidulce', 'Muy dulce'];
    const acidezWords = ['Baja', 'Media(-)', 'Media', 'Media(+)', 'Alta'];
    const taninoWords = ['Bajo', 'Medio(-)', 'Medio', 'Medio(+)', 'Alto'];
    const cuerpoWords = ['Poco', 'Medio(-)', 'Medio', 'Medio(+)', 'Alto'];
    const finalWords  = ['Corto', 'Medio(-)', 'Medio', 'Medio(+)', 'Largo'];
    const alcoholWords = ['Bajo', 'Medio', 'Alto'];

    const tastea = dulzorWords[selectedButtonGroup6.a] ?? '';
    const tasteb = acidezWords[selectedButtonGroup6.b] ?? '';
    const tastec = taninoWords[selectedButtonGroup6.c] ?? '';
    const tasted = cuerpoWords[selectedButtonGroup6.d] ?? '';
    const tastee = finalWords[selectedButtonGroup6.e] ?? '';
    const tastef = alcoholWords[selectedButtonGroup6.f] ?? '';

    
    const saveAnswers = async () => {
        const userLogged = JSON.parse(localStorage.getItem('userLogged'));
        const currentTest = JSON.parse(localStorage.getItem('currentTest'));

        if (!userLogged || !currentTest) {
            console.error("User or Test information is missing.");
            return;
        }

        const parseJSON = (value) => {
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        };

        const selectedButtonGroup0 = parseJSON(localStorage.getItem('selected0'));
        const selectedButtonGroup1 = parseJSON(localStorage.getItem('selected1'));
        const selectedButtonGroup2 = parseJSON(localStorage.getItem('selected2'));
        const selectedButtonGroup3 = parseJSON(localStorage.getItem('selected3'));
        const selectedButtonGroup4 = parseJSON(localStorage.getItem('selected4'));
        const selectedButtonGroup5 = parseJSON(localStorage.getItem('selected5'));
        const selectedButtonGroup6 = parseJSON(localStorage.getItem('selected6'));
        const selectedButtonGroup7 = {
            selectorVariedad,
            selectorPais,
            selectorRegion,
            selectorBodega,
            selectorMarca,
            selectorAnada,
        };
        const selectedButtonGroup8 = selectedPrice;

        console.log(test);
        const visual = calculateVisualPoints(test, selectedButtonGroup0, selectedButtonGroup1);
        const olfactory = calculateOlfactoryPoints(test, selectedButtonGroup2, selectedButtonGroup3, selectedButtonGroup4, selectedButtonGroup5);
        const taste = calculateTastePoints(test, selectedButtonGroup6);
        const variety = calculateVarietyPoints(test, selectedButtonGroup7);
        const price = calculatePricePoints(test, selectedButtonGroup8);

        const answers = {
            selectedButtonGroup0,
            selectedButtonGroup1,
            selectedButtonGroup2,
            selectedButtonGroup3,
            selectedButtonGroup4,
            selectedButtonGroup5,
            selectedButtonGroup6,
            selectedButtonGroup7,
            selectedButtonGroup8,
        };

        const payload = {
            object: answers,
            user_id: userLogged.id,
            test_id: currentTest.id,
            visual,
            visual_stats: 0,
            olfactory,
            olfactory_stats: 0,
            taste,
            taste_stats: 0,
            variety,
            variety_stats: 0,
            country_stats: 0,
            region_stats: 0,
            price,
            price_stats: 0,
        };

        console.log('Sending data:', payload);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/saveAnswer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            console.log('Response status:', response.status);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            console.log('Success:', data);

            // Borrar las variables del navegador
            localStorage.removeItem('currentTest');
            localStorage.removeItem('selected0');
            localStorage.removeItem('selected1');
            localStorage.removeItem('selected2');
            localStorage.removeItem('selected3');
            localStorage.removeItem('selected4');
            localStorage.removeItem('selected5');
            localStorage.removeItem('selected6');

            // Redirigir a /choose-wine
            window.location.href = '/choose-wine';
        } catch (error) {
            console.error('Error:', error);
        }
    };





    const calculateVisualPoints = (testObject, selectedOption0, selectedOption1) => {
    const intensityOfColor = testObject?.find(q => q.title === "Intensidad del color");
    const colorOfWine = testObject?.find(q => q.title === "Color del vino");

    let visual = 0;

    if (intensityOfColor?.question?.length) {
        intensityOfColor.question.forEach(option => {
        if (option.option === selectedOption0) {
            visual += Number(option.points) || 0;
        }
        });
    }

    if (colorOfWine?.question?.length) {
        colorOfWine.question.forEach(option => {
        if (option.option === selectedOption1) {
            visual += Number(option.points) || 0;
        }
        });
    }

    return visual;
    };


    const calculateOlfactoryPoints = (
    testObject,
    selectedOption2,
    selectedOptions3,
    selectedOptions4,
    selectedOption5
    ) => {
    const intensityOfAroma = testObject?.find(q => q.title === "Intensidad del aroma");
    const primaryAromas = testObject?.find(q => q.title === "Aromas primarios");
    const secondaryAromas = testObject?.find(q => q.title === "Aromas secundarios");
    const tertiaryAromas = testObject?.find(q => q.title === "Aromas terciarios");

    let olfactory = 0;

    if (intensityOfAroma?.question?.length) {
        intensityOfAroma.question.forEach(option => {
        if (option.option === selectedOption2) {
            olfactory += Number(option.points) || 0;
        }
        });
    }

    if (primaryAromas?.question?.length && Array.isArray(selectedOptions3)) {
        primaryAromas.question.forEach(option => {
        if (selectedOptions3.includes(option.option)) {
            olfactory += Number(option.points) || 0;
        }
        });
    }

    if (secondaryAromas?.question?.length && Array.isArray(selectedOptions4)) {
        secondaryAromas.question.forEach(option => {
        if (selectedOptions4.includes(option.option)) {
            olfactory += Number(option.points) || 0;
        }
        });
    }

    // Ojo: en tu código original selectedOption5 se trataba como array (includes)
    if (tertiaryAromas?.question?.length && Array.isArray(selectedOption5)) {
        tertiaryAromas.question.forEach(option => {
        if (selectedOption5.includes(option.option)) {
            olfactory += Number(option.points) || 0;
        }
        });
    }

    return olfactory;
    };


    const calculateTastePoints = (testObject, selectedOptions6) => {
    const sweetness = testObject?.find(q => q.title === "Dulzor");
    const acidity = testObject?.find(q => q.title === "Acidez");
    const tannin = testObject?.find(q => q.title === "Tanino");
    const body = testObject?.find(q => q.title === "Cuerpo");
    const finish = testObject?.find(q => q.title === "Final");
    const alcohol   = testObject?.find(q => q.title === "Alcohol");

    let taste = 0;

    const addPoints = (questionObj, selectedOption) => {
        if (!questionObj?.question?.length) return;

        questionObj.question.forEach(option => {
        if (option.option === selectedOption) {
            taste += Number(option.points) || 0;
        }
        });
    };

    // Mantengo tu lógica: a..e son 0/1/2 y lo conviertes a 1/2/3
    addPoints(sweetness, (selectedOptions6?.a ?? -999) + 1);
    addPoints(acidity, (selectedOptions6?.b ?? -999) + 1);
    addPoints(tannin, (selectedOptions6?.c ?? -999) + 1);
    addPoints(body, (selectedOptions6?.d ?? -999) + 1);
    addPoints(finish, (selectedOptions6?.e ?? -999) + 1);
    addPoints(alcohol,   (selectedOptions6?.f ?? -999) + 1);

    return taste;
    };


    const calculateVarietyPoints = (testObject, selection) => {
    if (!Array.isArray(testObject)) return 0;

    // 1) Variedad (lista simple)
    const variedadQuestion = testObject.find(q => q.title === "Variedad");
    const variedadItem = variedadQuestion?.question?.find(v => v.option === selection.selectorVariedad);
    const variedadPoints = Number(variedadItem?.points) || 0;

    // 2) País -> Región -> Bodega -> Marca (árbol)
    const paisQuestion = testObject.find(q => q.title === "Pais");
    const paisData = paisQuestion?.question || [];

    const selectedPais = paisData.find(p => p.Pais === selection.selectorPais);
    const paisPoints = Number(selectedPais?.points) || 0;

    const selectedRegion = selectedPais?.regiones?.find(r => r.region === selection.selectorRegion);
    const regionPoints = Number(selectedRegion?.points) || 0;

    const selectedBodega = selectedRegion?.bodegas?.find(b => b.bodega === selection.selectorBodega);
    const bodegaPoints = Number(selectedBodega?.points) || 0;

    const selectedMarca = selectedBodega?.marcas?.find(m => m.marca === selection.selectorMarca);
    const marcaPoints = Number(selectedMarca?.points) || 0;
    
    // 3) Añada (lista simple)
    const anadaQuestion = testObject.find(q => q.title === "Añada");

    // OJO: en el JSON puede venir como número o string, por eso comparamos con Number()
    const anadaSelectedValue = Number(selection.selectorAnada) || 0;

    const anadaItem = anadaQuestion?.question?.find(a => Number(a.option) === anadaSelectedValue);
    const anadaPoints = anadaItem ? (Number(anadaItem.points) || 0) : 0;

    return variedadPoints + paisPoints + regionPoints + bodegaPoints + marcaPoints + anadaPoints;
    };

    const calculatePricePoints = (testObject, selectedPrice) => {
    const priceQuestion = testObject?.find(q => q.title === "Precio");
    if (!priceQuestion?.question?.length) return 0;

    const selectedOption = priceQuestion.question.find(
        option => String(option.option) === String(selectedPrice)
    );

    return Number(selectedOption?.points) || 0;
    };

    useEffect(() => {
    if (onSaveAnswers) onSaveAnswers(saveAnswers);
    }, [selectorVariedad, selectorPais, selectorRegion, selectorBodega, selectorMarca, selectorAnada, selectedPrice]);

    return (
        <div className="slide-container">
            <div className="overlay" id="instructions-div">
                <img src={instructions} alt="Imagen" className="centered-image dekstop" onClick={handleQuitInstructions} />
                <img src={Rinstructions} alt="Imagen" className="centered-image mobile" onClick={handleQuitInstructions} />
            </div>
            <div className="actual-wine">{title}</div>
            <h2>Nota de cata</h2>
            <div className="cont-sub-section">
            <div className="text-note col-sub-section-2">
                    <p>Este vino tiene un color <span>{selectedButtonGroup1} {selectedButtonGroup0}</span>. En nariz tiene una <span>intensidad {selectedButtonGroup2}</span> con aromas primarios <span>({selectedButtonGroup3.join(", ")})</span>, aromas secundarios <span>({selectedButtonGroup4.join(", ")})</span> y aromas terciarios <span>({selectedButtonGroup5.join(", ")}). </span>
                        Es un vino <span>{tastea}</span>,
                        con acidez <span>{tasteb}</span>,
                        tanino <span>{tastec}</span>,
                        alcohol <span>{tastef}</span>,
                        cuerpo <span> {tasted} </span>
                        y final <span>{tastee}</span>.</p>
                    
            </div>
            
            <div className="col-sub-section-2">
            <div className="note-select-container">
            <h4>Variedad</h4>
            <SelectorSearch
                opciones={opcionesVariedad}
                value={selectorVariedad}
                onChange={setSelectorVariedad}
                className="note-selector"
            />
            </div>
            <div className="note-select-container">
            <h4>País</h4>
            <SelectorSearch opciones={opcionesPais} value={selectorPais} onChange={handlePaisChange} className="note-selector"/>
            </div>

            <div className="note-select-container">
            <h4>Región</h4>
            <SelectorSearch opciones={opcionesRegion} value={selectorRegion} onChange={handleRegionChange} isDisabled={!selectorPais} className="note-selector"/>
            </div>

            <div className="note-select-container">
            <h4>Bodega</h4>
            <SelectorSearch opciones={opcionesBodega} value={selectorBodega} onChange={handleBodegaChange} isDisabled={!selectorPais || !selectorRegion} className="note-selector"/>
            </div>

            <div className="note-select-container">
            <h4>Marca</h4>
            <SelectorSearch opciones={opcionesMarca} value={selectorMarca} onChange={setSelectorMarca} isDisabled={!selectorPais || !selectorRegion || !selectorBodega} className="note-selector"/>
            </div>
            <div className="note-select-container añada">
            <h4>Añada</h4>
            <SelectorSearch
                opciones={opcionesAnada}
                value={selectorAnada}
                onChange={(v) => setSelectorAnada(v === "" ? 0 : Number(v))}
                className="note-selector"
            />
            </div>
            <div className="note-select-container precio-container">
            <h4>Precios</h4>
            <div className="col-sub-section sub-section-container" role="group">
            {priceOptions.map((opt) => (
                <button
                key={String(opt.value)}
                type="button"
                className={`btn ${String(selectedPrice) === String(opt.value) ? 'btn-selected' : 'btn-olfatory'}`}
                onClick={() => handlePriceClick(opt.value)}
                >
                {opt.label}
                </button>
            ))}
            </div>
            </div>
            </div>
            </div>
            
        </div>

    );
};

export default SlideComponent;